import { enqueueSnackbar } from '.';

export function addSuccessToast(dispatch: any, message: string) {
	dispatchToast(dispatch, message, 'success');
}

export function addErrorToast(dispatch: any, message: string) {
	dispatchToast(dispatch, message, 'error');
}

export function addInfoToast(dispatch: any, message: string) {
	dispatchToast(dispatch, message, 'info');
}

export function addWarningToast(dispatch: any, message: string) {
	dispatchToast(dispatch, message, 'warning');
}

const dispatchToast = (dispatch: any, message: string, variantType: string) => {
	dispatch(
		enqueueSnackbar({
			message: message,
			options: {
				key: new Date().getTime() + Math.random(),
				variant: variantType,
			},
		})
	);
};
